import InitiativeDetail from '../../components/light/initiative/InitiativeDetail';

const initiative = {
  title: 'Yoruba Heritage & Language Cultural Literacy',
  category: 'Culture & Heritage',
  year: '2019',
  location: 'Oyo, Osun & Lagos States',
  heroImage: '/light/assets/imgs/spob/initiative-4.jpg',
  need: {
    headline:
      'Rapid urbanisation and the dominance of English media are eroding native Yoruba language fluency and cultural identity among younger generations.',
    body: 'Many young Yoruba people cannot hold a conversation in their mother tongue, recite traditional proverbs, or participate in cultural ceremonies. As elders who carry oral traditions pass on, knowledge of Yoruba history, music, and values risks being lost. SPOB recognised this cultural emergency and created structured, joyful spaces where young people can rediscover and celebrate their heritage.',
  },
  approach: {
    headline:
      'SPOB creates safe, joyful spaces for young people to learn, speak, and celebrate Yoruba language and culture.',
    body: 'Through weekly community language circles, youth storytelling competitions, and an annual Yoruba Heritage Festival, SPOB makes cultural literacy accessible and engaging. Youth Yoruba clubs are established in secondary schools with trained facilitators who teach conversational Yoruba, proverbs, music, and folklore. Elder-youth pairing sessions connect knowledge holders with the next generation in a structured mentorship format.',
  },
  stats: [
    { number: '40', label: 'Language Clubs Established' },
    { number: '2,000+', label: 'Youth Participants' },
    { number: '1', label: 'Annual Heritage Festival' },
  ],
  next: {
    title: 'Eco-Awareness & Environmental Sustainability',
    href: '/light/initiative-eco',
  },
};

export default function InitiativeYoruba() {
  return <InitiativeDetail initiative={initiative} />;
}
